import React from 'react';
import Info from 'components/Info';
import TestimonialCard from 'components/TestimonialCard';
import './Testimonial.css';

function Testimonials() {
  return (
    <div className="testimonialBgColor">
      <div className=" 
        mt-3 pt-6
        sm:mx-5 sm:mb-5 
        md:mx-10 md:mb-5 
        lg:mx-48 lg:mb-5"
      >
        <div>
          <Info title = {'Testimonials'} dcp = {"Providing exceptional service with a single source of truth for our clients across the globe."}/>
        </div>
      </div>

      <TestimonialCard />
    </div>
  )
}

export default Testimonials;